import { useNavigate } from "react-router-dom";
import { Case } from "../../../models/case";

const IconChevron = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
    <path d="M3 1l4 4-4 4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

function CaseRow({ caseObject }: { caseObject: Case }) {
  const navigate = useNavigate();

  if (!caseObject?.id) return null;

  return (
    <tr onClick={() => navigate(`/case/${caseObject.id}/overview`)} style={{ cursor: "pointer" }}>
      <td>
        <span style={{ fontFamily: "var(--mono)", fontSize: 13, fontWeight: 600, color: "var(--maroon)" }}>
          {caseObject.caseNumber}
        </span>
      </td>
      <td>
        <div style={{ fontWeight: 500 }}>{caseObject.address?.line1 || "—"}</div>
        {caseObject.address?.city && (
          <div style={{ fontSize: 12, color: "var(--ink-soft)" }}>{caseObject.address.city}{caseObject.address.state ? `, ${caseObject.address.state}` : ""}</div>
        )}
      </td>
      <td style={{ color: "var(--ink-soft)" }}>
        {caseObject.buyersAgent?.name || "—"}
      </td>
      <td>
        <span className="p-pill green"><span className="dot" />Active</span>
      </td>
      <td>
        <span style={{ color: "var(--ink-soft)" }}><IconChevron /></span>
      </td>
    </tr>
  );
}

export default CaseRow;
